import React, { useEffect } from "react"
import { Button, Flex, Heading } from "@chakra-ui/react"
import { BreadCrumb } from "../../../components/commons/breadcrumb"
import { FMPTableType, Paths, breadCrumbFirstLevel } from "../../../common/commonConstants"
import { SubPage, SubPageContent } from "../../../components/SubPage"
import { scrollTo } from "../../../components/commons/utils"
import { CreateNewFMP } from "../createNewFMPButton.main"
import { useNavigate } from "react-router-dom"
import { MyFMPTable } from "./myFMPs.support"

export const MyArchivedFMPs = (): JSX.Element => {
  useEffect(() => {
    scrollTo(0, 0)
  }, [])
  const navigate = useNavigate()
  const navigateToMyFMP = (): void => {
    navigate(Paths.FMP.MY_FMP)
  }

  return (
    <SubPage>
      <BreadCrumb
        options={{
          ...breadCrumbFirstLevel,
          thirdLevel: { title: "MyFMPs" }
        }}
      />

      <SubPageContent props={{ pt: "22px" }} innerBoxProps={{ w: "90%" }}>
        <Flex justifyContent="space-between" alignItems="center" w="100%" mb="3">
          <Heading variant="RHeading1" textAlign="left" color="primary">
            My FMPs - Archived
          </Heading>
          <Flex justifyContent="flex-end" alignItems="center" gridGap="12px">
            <Button variant="Button1RegularOutline" onClick={navigateToMyFMP}>
              Show Active FMPs
            </Button>
            <CreateNewFMP buttonProps={{ variant: "Button1RegularAccentWithShadow" }} />
          </Flex>
        </Flex>
        <MyFMPTable variant={FMPTableType.MY_ARCHIVED_FMP} />
      </SubPageContent>
    </SubPage>
  )
}
